import { useEffect, useState } from 'react'
import { getClient } from '@lib/sanity'
import { useRouter } from 'next/router'

const SiteAnnouncement = () => {
  const { locale } = useRouter()
  const [announcement, setAnnouncement] = useState(null)

  useEffect(() => {
    getClient(false)
      .fetch(`*[_type == "announcement" && active == true][0]`)
      .then((data) => setAnnouncement(data))
      .catch(console.error)
  }, [])

  if (!announcement) {
    return null
  }

  const content = (
    <div className="bg-primary-100 py-4">
      <div className="container">
        <div className="flex flex-row flex-nowrap items-center justify-center">
          <p className="leading-tight">
            {announcement.title[locale] || announcement.title.en}
          </p>
          {announcement.buttonText && (
            <div className="ml-4 whitespace-nowrap rounded-full border-2 border-accent-500 py-1 px-4 text-accent-500">
              {announcement.buttonText[locale] || announcement.buttonText.en}
            </div>
          )}
        </div>
      </div>
    </div>
  )

  if (announcement.link) {
    return (
      <a
        className="block"
        href={announcement.link[locale] || announcement.link.en}
      >
        {content}
      </a>
    )
  }
  return content
}
export default SiteAnnouncement
